import { useState, useEffect } from 'react';
import { Container, Row, Col, Nav, Navbar } from 'react-bootstrap';
import { Link } from "react-router-dom";
import LogoText from "../assets/images/logo/logotext.png";
import StripeImage from "../assets/stripe/image-1.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGripLines, faShoppingBag, faTrash } from '@fortawesome/free-solid-svg-icons';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { useCart, } from "./Cart";

function NavbarLight() {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [shoppingBag, setShoppingBag] = useState(false);

    const handleCloseShoppingBag = () => setShoppingBag(false);
    const handleShowShoppingBag = () => setShoppingBag(true);

    const [isVisible, setIsVisible] = useState(true); // Tracks visibility of the navbar
    const [lastScrollY, setLastScrollY] = useState(0); // Tracks the last scroll position

    // Handle scroll behavior
    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            if (currentScrollY > lastScrollY) {
                // Scrolling down
                setIsVisible(false);
            } else {
                // Scrolling up
                setIsVisible(true);
            }

            setLastScrollY(currentScrollY);
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [lastScrollY]);

    const { cart, removeFromCart, isCartOpen, setIsCartOpen } = useCart();

    return (
        <>
            <Navbar
                expand=""
                className={`sticky-top bg-white py-4 ${isVisible ? "navbar-visible" : "navbar-hidden"}`}
                style={{
                    transition: "transform 0.3s ease-in-out",
                    transform: isVisible ? "translateY(0)" : "translateY(-100%)"
                }}
            >
                <Container>
                    <button className="btn border-0 text-dark" onClick={handleShow}><FontAwesomeIcon icon={faGripLines} /></button>
                    <Navbar.Brand className="mx-auto"><Link to="/"><img src={LogoText} width="180" /></Link></Navbar.Brand>
                    <button className="btn border-0 text-dark" onClick={handleShowShoppingBag}><FontAwesomeIcon icon={faShoppingBag} /></button>
                </Container>
            </Navbar>

            <Offcanvas
                show={show}
                onHide={handleClose} className="custom-offcanvas"

            >
                <Offcanvas.Header closeButton className="p-4">
                </Offcanvas.Header>
                <Offcanvas.Body className="d-flex flex-column align-items-center justify-content-center">
                    <div className="w-100 text-start mt-5">
                        <Nav className="flex-column ps-3 mt-5 text-uppercase text-small">
                            {/* <Nav.Link> */}
                            <Link to="/shop" className="text-decoration-none text-dark mb-3">Shop</Link>
                            <Link to="/alteration" className="text-decoration-none text-dark mb-3">Alteration</Link>
                            {/* </Nav.Link> */}
                            {/* <Nav.Link> */}
                            <Link to="/about" className="text-decoration-none text-dark mb-3">About</Link>
                            {/* <Link to="/book-appointment" className="btn btn-dark text-decoration-none text-small rounded-0 mb-3">Book an Appointment</Link> */}
                            {/* </Nav.Link> */}
                        </Nav>
                    </div>
                    <Row className="mt-auto mb-4">
                        <Col className="d-flex justify-content-center">
                            <img src={LogoText} width="200" alt="Logo Text" />
                        </Col>
                    </Row>
                </Offcanvas.Body>
            </Offcanvas>

            <Offcanvas
                show={shoppingBag}
                onHide={handleCloseShoppingBag}
                placement="end"
            // className={`${isCartOpen ? "show" : ""}`} style={{ display: isCartOpen ? "block" : "none" }}
            >
                <Offcanvas.Header closeButton className="me-auto p-4">
                </Offcanvas.Header>
                <Offcanvas.Body className="">
                    {/* <div className="d-flex align-items-center py-5"> */}
                        <Container>
                            <Row>
                                <Col lg={12} className="d-flex justify-content-center">
                                    {cart.length === 0 ? (
                                        <p className="py-5">Your bag is empty</p>
                                    ) : (
                                        <Container>
                                            {cart.map((item) => (
                                                <Row className="mb-3">
                                                    <Col lg={5} xs={5}>
                                                        <img src={item.images} className="img-fluid" />
                                                    </Col>
                                                    <Col lg={7} xs={7}>
                                                        <p className="mb-0">{item.name}</p>
                                                        <p className="text-uppercase">{(item.unit_amount / 100).toFixed(2)} {item.currency}</p>
                                                        <p className="text-small">{item.quantity} item(s)</p>
                                                        <button
                                                            className="btn btn-sm btn-light rounded-0"
                                                            onClick={() => removeFromCart(item.id)}
                                                        >
                                                            <FontAwesomeIcon icon={faTrash} />
                                                        </button>
                                                    </Col>
                                                </Row>
                                            ))}
                                            <hr />
                                            <Row>
                                                <Col lg={12} className="mb-5">
                                                <p className="text-small">
                                                Sub total <span className="float-end text-uppercase">
                                                            {cart
                                                                .reduce(
                                                                    (acc, item) =>
                                                                        acc + (item.unit_amount / 100) * item.quantity,
                                                                    0
                                                                )
                                                                .toFixed(2)} AED </span>
                                                </p>
                                                    <h5 className="fw-bold">
                                                        Total <span className="float-end text-uppercase">
                                                            {cart
                                                                .reduce(
                                                                    (acc, item) =>
                                                                        acc + (item.unit_amount / 100) * item.quantity,
                                                                    0
                                                                )
                                                                .toFixed(2)} AED </span>
                                                    </h5>
                                                </Col>
                                                <Col>
                                                    <div className="d-grid gap-2">
                                                    <Link to="/checkout" className="btn btn-dark rounded-3">
                                                            Checkout
                                                        </Link>
                                                        {/* <button className="btn btn-dark rounded-3">
                                                            Checkout
                                                        </button> */}
                                                    </div>
                                                    {/* <img src={StripeImage} className="img-fluid p-5" /> */}
                                                </Col>
                                            </Row>
                                        </Container>
                                    )}

                                </Col>
                            </Row>
                        </Container>

                    {/* </div> */}
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}

export default NavbarLight;